import React, {useContext, useEffect} from 'react';
import {Auth} from 'aws-amplify';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
import useStyles from './AppHeader.style';
import AppLogo from '../../../../shared/components/AppLogo';
import Typography from '@material-ui/core/Typography';
import ExitToApp from '@material-ui/icons/ExitToApp';
import clsx from 'clsx';
// import {
//   useLayoutActionsContext,
// } from '../LayoutContextProvider';
import AppContextPropsType from '../../../../types/AppContextPropsType';
import AppContext from '../../../utility/AppContext';
import {useHistory} from 'react-router-dom';
import {
  Card,
  Chip,
  CircularProgress,
  FormControl,
  Grid,
  TextField,
} from '@material-ui/core';
import {TenantContext} from 'contexts';
import TenantContextPropTypes from 'contexts/tenant/ContextPropTypes';
import {Autocomplete} from '@material-ui/lab';
interface AppHeaderProps {}

const AppHeader: React.FC<AppHeaderProps> = () => {
  const classes = useStyles();
  //const dispatch = useLayoutActionsContext()!;
  const history = useHistory();
  const {
    user,
    config,
    tenancyOn,
    tenancyEnabled,
  } = useContext<AppContextPropsType>(AppContext);
  const GLOBAL_TENANT = {
    key: 'GLOBAL CONTEXT',
  };
  const {
    currentTenant,
    currentTenantLoaded,
    availableTenants,
    switchCurrentTenant,
  } = useContext<TenantContextPropTypes>(TenantContext);

  const signOutButton = async function signOut(): Promise<void> {
    try {
      await Auth.signOut();
      history.push('/');
    } catch (error) {
      console.warn('error signing out: ', error);
    }
  };
  const handleSwitchTenant = (event, value) => {
    switchCurrentTenant(value);
  };

  return (
    <>
      <AppBar color='inherit' className={clsx(classes.appBar, 'app-bar')}>
        <Toolbar className={classes.appToolbar}>
          <AppLogo />
          <Box className={classes.grow} />
          <Box className={classes.sectionDesktop}>
            {tenancyEnabled && tenancyOn && (
              <Box style={{marginRight: '20px'}}>
                <FormControl className={classes.formControl}>
                  {currentTenant ? (
                    <Autocomplete
                      options={availableTenants}
                      getOptionLabel={(option) => option.key}
                      id='tenant-select'
                      value={currentTenant}
                      disableClearable
                      onChange={handleSwitchTenant}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                          <Chip
                            variant='outlined'
                            label={option}
                            {...getTagProps({index})}
                          />
                        ))
                      }
                      renderInput={(params) => (
                        <TextField
                          className={classes.tenantSelectionInput}
                          fullWidth
                          variant='outlined'
                          {...params}
                          margin='dense'
                        />
                      )}
                    />
                  ) : (
                    <Box style={{color: 'white', fontSize: '30px'}}>
                      <Typography variant='h6'>
                        <CircularProgress
                          style={{marginRight: '5px'}}
                          size='25px'
                        />{' '}
                        Loading tenants ...
                      </Typography>
                    </Box>
                  )}
                </FormControl>
              </Box>
            )}

            <Chip
              className={classes.envChip}
              color='primary'
              size='small'
              label={config.environment.toUpperCase()}
            />
            <Chip
              className={classes.envChip}
              color='primary'
              size='small'
              label={user.userType.toUpperCase()}
            />
            <Typography className={classes.userName}>
              {user?.email}
            </Typography>
            <IconButton
              className={classes.logoutIcon}
              color='inherit'
              onClick={signOutButton}
              aria-label='userName'>
              <ExitToApp />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
};
export default AppHeader;
